import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCGrid, RCCHookToast, RCCRefModalProps, RCCServicesApi, RCCTextArea } from "react-common-components";
import { useForm } from "react-hook-form";
import Modal from "src/components/Modal";
import ModalSide from "src/components/Modal/styles";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import IMarketShareAttachmentsRef from "./interface";

const AttachmentsModal: React.ForwardRefRenderFunction<IMarketShareAttachmentsRef> = (_, ref) => {
	const { translate } = useTranslation();
	const { setLoading } = useLoaderBackdrop();
	const { addToast } = RCCHookToast();

	const modalAttachment = useRef<RCCRefModalProps>(null);
	const [mab002Id, setMab002Id] = useState(0);
	const [mab004Id, setMab004Id] = useState(0);
	const [permissions, setPermissions] = useState(false);
	const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
	const [comment, setComment] = useState("");
	const onCallbackAttachments = useRef<Function | undefined>(undefined);

	const { 
		handleSubmit, 
		register, 
		reset, 
		clearErrors 
	} = useForm();


	const openModalComments = async (mab002IdX: number, mab004IdX: number, titleOkr: string, permissionsX: boolean, onCallback?: Function) => {
		reset();
		setComment("");
		try{
			setLoading(true);

			const {data} = await RCCServicesApi.getRequest({
				method: "MarketShare/SelectComment",
				urlParameters: {
					mab002Id: mab002IdX,
					mab004Id: mab004IdX
				}
			});

			setComment(data);
			onCallbackAttachments.current = onCallback;
			setPermissions(permissionsX);
			setLoading(false);
			setMab002Id(mab002IdX);
			setMab004Id(mab004IdX);
			setSubtitle(`${translate("Concorrente")}: ${titleOkr}`);

			modalAttachment.current?.openModal();
		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao buscar comentário"), addToast);
		}
	};

	const submit = async (data: any) => {
		try{
			clearErrors();
			modalAttachment.current?.setLoadingButton();

			await RCCServicesApi.putRequest({
				method: "MarketShare/UpdateComment",
				body: {
					...data,
					mab002Id,
					mab004Id
				}
			});

			addToast({
				color: "green",
				description: translate("Comentário adicionado com sucesso"),
				title: translate("Sucesso")
			});

			modalAttachment.current?.resetLoadingButton();
			modalAttachment.current?.closeModal();
            
			if(onCallbackAttachments.current)
				onCallbackAttachments.current();
		}catch(err){
			standardErrorMessages(err, translate("Erro ao adicionar comentário"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openModalComments
	}));

	return (
		<>
			
			<Modal
				ref={modalAttachment}
				header={{
					title: translate("Comentário"),
					subtitle,
					icon: {
						name: "comment"
					}
				}}
				footer= {{
					showSaveButton: permissions,
					buttonLoadingText: translate("Carregando"),
					saveButtonText: translate("Salvar"),
					cancelButtonText: translate("Cancelar")
				}}
				onSubmit={handleSubmit(submit)}
				styleInline={`${ModalSide} height: 30%; min-height: 300px;`}
			>
				<RCCGrid container item direction="column">
					<RCCTextArea 
						register={register}
						name="Comment"
						label=""
						maxLength={4000}
						defaultValue={comment}
						styleInline="height: 34px;"
						disabled={!permissions}
					/>
				</RCCGrid>
			</Modal>
			
		</>
	);
};

export default forwardRef(AttachmentsModal);
